module.exports = __webpack_public_path__ + "img/pubpeer-publication.5ddbd71b.png";